const ratebookDefaultValues = {
  results: [],
  currentPageResults: [],
  pageSize: 25,
  pageNumber: 1,
  resultCount: 0
};

export default {
  namespaced: true,
  state: {
    ratebook: ratebookDefaultValues,
    ratebookLoading: false
  },
  getters: {
    getRatebook(state) {
      return state.ratebook;
    },
    getRatebookLoading(state) {
      return state.ratebookLoading;
    },
    getRatebookResults(state) {
      return state.ratebook.results;
    }
  },
  mutations: {
    setRatebook(state, { results, pageSize, pageNumber, resultCount }) {
      state.ratebook = {
        ...state.ratebook,
        ...(results && { results }),
        ...(pageSize && { pageSize }),
        ...(pageNumber && { pageNumber }),
        ...(resultCount && { resultCount })
      };
    },
    setRatebookLoading(state, ratebookLoading) {
      state.ratebookLoading = ratebookLoading;
    },
    clearRatebook(state) {
      state.ratebook = ratebookDefaultValues;
    }
  },
  actions: {
    updateRatebook({ commit }, ratebook) {
      commit('setRatebook', ratebook);
    },
    updateRatebookLoading({ commit }, ratebookLoading) {
      commit('setRatebookLoading', ratebookLoading);
    },
    clearRatebook({ commit }) {
      commit('clearRatebook');
    }
  }
};
